<template>
    <section class="filter-view">
                <filter-menu ref="menu" id="filter-menu-bar" :isTeamPage="contentType == 'teammember'" :showAlphabetically="showAlphabetically" :Menus="Menus" v-on:apply-filters="applyClicked" v-on:toggle-sort="toggleSort" :tags="currentTags">
                    <template v-for="(index, name) in $slots" v-slot:[name]>
                        <slot :name="name" />
                    </template>
                </filter-menu>
        <div v-if="initialLoad">
             <p class="filter-view-loading"><slot name="hl-filterview-loading"></slot></p>
        </div>
        <div  v-if="filteredContent.length <= 0 && !initialLoad">
            <p class="filter-view-loading"><slot name="hl-filterview-noresults"></slot></p>
        </div>

        <section v-if="contentType == 'news' || contentType == 'insight'" class="article-tile-grid">
            <div class="article-tile-grid-main">
                <transition-group name="article-tile-grid-container" ref="tilegrid" class="article-tile-grid-container ie-grid" tag="ul" mode="out-in">
                    <article-tile v-for="(item, index) in filteredContent" :tileObject="item" :key="item.Headline + forceRenderKey" :icon="getIconForItem(item)" :heading="getEyebrowForItem(item)" :displayTile="item.DisplayTile" class="" :image-url="item.Image" v-if="index >= currentPage*itemsPerPage && index < (currentPage+1)*itemsPerPage" :url="item.Url">
                        <template v-slot:title>
                            {{item.Headline}}
                        </template>
                        <template v-slot:description>
                            {{item.Description}}
                        </template>
                        <template v-slot:link>
                            {{item.CtaText}}
                        </template>
                    </article-tile>

                    <subscribe-tile :class="{ 'subscribe-fixed-pos': (filteredContent.length - currentPage*itemsPerPage >= 6) }" :key="'subscribetile'" :cultureCode="cultureCode">
                        <template v-for="(index, name) in $slots" v-slot:[name]>
                            <slot :name="name" />
                        </template>
                    </subscribe-tile>
                </transition-group>
            </div>
        </section>

        <section class="team-member-grid" v-if="contentType == 'teammember'" v-for="team in filteredContent">   
            <h2 v-if="team.TeamName != ''" class="related-team-members-heading heading-3 heading-is-underlined">{{team.TeamName}}</h2>                 
            <div class="row row-cols-lg-5 mb-4 ">
                <div class="col col-md-6" v-for="(item, index) in team.Team" :key="item.Headline">
                    <team-member
                        :teamMemberDetailPage="item.Url"
                        :imageUrl="item.ImageUrl"
                        :imageAltText="item.ImageAltText"
                        :teamMemberName="item.FullName"
                        :teamMemberTitle="item.Title"
                    />
                </div>
            </div>

        </section>

        <pagination
            v-if="contentType != 'teammember' && maxPage > 1"
            :currentPage="currentPage"
            :maxPage="maxPage"
            v-on:prev-page="onPrevPage"
            v-on:next-page="onNextPage"
        />

    </section>

</template>

<style lang="scss">
    .filter-view {
        padding-top: $bigPaddingSize/2;

        @include respond-above(xl) {
            padding: $bigPaddingSize/2;
        }

        .article-tile-grid-container {
            margin-top: 0;
        }

        .article-tile-grid-container-item {
            display: inline-block;
            margin-right: 10px;
        }

        .article-tile-grid-container-enter-active, .article-tile-grid-container-leave-active {
            transition: all 0.15s;
        }

        .article-tile-grid-container-enter, .article-tile-grid-container-leave-to {
            opacity: 0;
            transform: translateY(30px);
        }

    }
</style>


<script>
    import Vue from 'vue';
    import FilterMenu from "../systems/FilterMenu";
    import ArticleTileGrid from "../systems/ArticleTileGrid";

    import ArticleTile from "../components/ArticleTile";
    import SubscribeTile from "../components/SubscribeTile";
    import TeamMember from "../components/TeamMember";

    import FeaturedInsightsBlock from "../systems/FeaturedInsightsBlock.vue";
    import Pagination from "../components/Pagination";

    import ieGrid from '../js/modules/ie-grid.js';

    //ieGrid.test();


    export default {
        components: {
            ArticleTile,
            SubscribeTile,
            FilterMenu,
            ArticleTileGrid,
            FeaturedInsightsBlock,
            TeamMember,
            Pagination
        },
        data() {
            return {
                currentPage: 0,
                chapteredContentPage: 0,
                itemsPerPage: 14,
                forceRenderKey: 0,
                filteredContent: [],
                currentTags: [],
                initialLoad: true,
                showAlphabetically: false,
                "Content": [],
                "Menus": []
            }

        },
        props: {
            contentType: {
                type: String,
                default: "insight"
            },
            cultureCode: {
                type: String,
                default: "en-US"
            },
            includeSubscribeTile: {
                type: Boolean,
                default: false
            },
            debugMode: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            filteredContent: function (val) {
                this.updateIEGrid();
            }
            // contentType(newType, oldType) {
            // 	this.getContent();
            // }
        },
        mounted() {
            // DEBUG:
            if (this.debugMode) {
                // this.createDummyContent();
                this.initialLoad = false;
                this.apply();

            } else {
                this.Content = [];
                this.Menus = [];
                this.filteredContent = [];

                this.getContent();

            }

            window.addEventListener('popstate', (event) => {
                console.log("Pop state", event.state);

                if (event.state) {
                    this.Menus = event.state.Menus;
                    this.showAlphabetically = event.state.showAlphabetically;
                    this.apply();
                    this.currentPage = event.state.currentPage;

                } else {
                    // this.Menus.forEach(menu => {
                    // 	menu.Items.forEach( item => {
                    // 		item.isChecked = false;
                    // 	});
                    // });
                    // this.currentPage = 0;

                    // this.apply();
                }
            });

        },
        computed: {
            maxPage() {
                return Math.ceil(this.filteredContent.length / this.itemsPerPage);
            }
        },
        methods: {
            updateIEGrid() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs["tilegrid"]) {
                            ieGrid.doIEGrid(
                                this.$refs["tilegrid"].$el,
                                {
                                    numCols: 3,
                                    maxRows: 10,
                                    useGutters: true,
                                    gridRowTemplate: "260px 20px"
                                }
                            );
                        }
                    }, 250);		// delay is to ensure that animations have finished..
                });
            },
            getContent() {
                if (this.contentType == "news") {
                    this.getDataFromEndpoint(this.cultureCode.toLowerCase() + '/articledata/news');
                }
                if (this.contentType == "insight") {
                    this.getDataFromEndpoint(this.cultureCode.toLowerCase() + '/articledata/insight');
                }
                if (this.contentType == "teammember") {
                    this.getDataFromEndpoint(this.cultureCode.toLowerCase() + '/teamdata');
                }
            },
            getIconForItem(item) {
                if (!item.Data)
                    return "";

                return item.Data.Icon;
            },
            getEyebrowForItem(item) {
                if (!item.Data)
                    return "";

                return item.Data.Eyebrow;
            },
            getDataFromEndpoint(endpointPath) {

                this.$axios.get(endpointPath)
                    .then((response) => {
                        this.initialLoad = false;
                        //console.log(response.data);
                        response.data.Menus.forEach(menu => {
                            menu.Items.forEach(item => {
                                item.isChecked = false;
                            })
                        });

                        response.data.Content.forEach(item => {
                            item.isShown = true;

                            if (item.DisplayTile == "ChapteredContent" && Array.isArray(item.ChapteredArticles)) {
                                let articles = item.ChapteredArticles;

                                articles.forEach((visArt) => { visArt.isShown = true })
                                articles = articles.map(x => x).splice(0, 3);  // limit 3 max?

                                item.visibleArticles = articles;
                            }
                        });

                        this.Content = response.data.Content;
                        this.Menus = response.data.Menus;
                        this.parseUrlState();

                        this.replaceCurrentState();
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            hasAnyFilters() {
                return this.Menus.some(menu => menu.Items.some(menuItem => menuItem.isChecked));
            },
            onNextPage() {
                if (this.currentPage < this.maxPage - 1) {
                    this.currentPage += 1;
                }
                this.updateIEGrid();
                this.pushCurrentState();
                this.$refs.menu.$el.scrollIntoView(true);
            },
            onPrevPage() {
                if (this.currentPage > 0) {
                    this.currentPage -= 1;
                }
                this.updateIEGrid();

                this.pushCurrentState();
                this.$refs.menu.$el.scrollIntoView(true);
            },
            toggleSort() {
                this.showAlphabetically = !this.showAlphabetically;
                this.pushCurrentState();
                this.apply();
            },
            pushCurrentState() {
                console.log("push state")

                history.pushState({ Menus: this.Menus, currentPage: this.currentPage, showAlphabetically: this.showAlphabetically }, "", this.getStateAsUrl());
            },
            replaceCurrentState() {
                history.replaceState({ Menus: this.Menus, currentPage: this.currentPage, showAlphabetically: this.showAlphabetically }, "");
            },
            getStateAsUrl() {

                let menuSections = ["filterState=true", "showAlphabetically=" + this.showAlphabetically, "currentPage=" + this.currentPage]
                this.Menus.forEach(menu => {
                    let checkedItems = [];

                    menu.Items.filter(menuItem => menuItem.isChecked).forEach(menuItem => {
                        checkedItems.push(encodeURIComponent(menuItem.FieldValue));
                    });


                    if (checkedItems.length > 0) {
                        menuSections.push(encodeURIComponent("menu_" + menu.FieldName) + "=" + checkedItems.join(encodeURIComponent(",")));
                    }



                });
                return "?" + menuSections.join("&");
            },
            parseUrlState() {
                console.log("Parse url state");
                // should be run after we have pulled data from the endpoint

                if (typeof (URLSearchParams) == "undefined") {
                    this.apply();
                    return;

                }
                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams.get("filterState") != "true") {
                    this.apply();
                    return;
                }

                this.showAlphabetically = (urlParams.get("showAlphabetically") == "true");

                this.Menus.forEach(menu => {
                    if (urlParams.has("menu_" + menu.FieldName)) {
                        let checkedItems = urlParams.get("menu_" + menu.FieldName).split(",");

                        menu.Items.forEach(menuItem => {
                            if (checkedItems.includes(menuItem.FieldValue)) {
                                menuItem.isChecked = true;
                            }
                        });
                    }
                });
                this.apply();	// apply sets current page to zero
                this.currentPage = Number(urlParams.get("currentPage"));

            },
            applyClicked() {
                // must set page to zero here so it is saved
                this.currentPage = 0;
                this.pushCurrentState();
                this.apply();
            },
            apply() {
                this.currentPage = 0;

                let tags = this.Menus.map(menu => menu.Items.filter(menuItem => menuItem.isChecked))
                    .reduce((list, currentValue) => {
                        return list.concat(currentValue)
                    }, []);

                this.currentTags = tags;

                if (this.hasAnyFilters()) {
                    //console.log(this.getStateAsUrl());



                    let Menus = this.Menus;

                    function filterArticle(item) {
                        item.isShown = false;
                        let anyMenusFailed = false;

                        // If any any filters match, show this item?
                        Menus.forEach(menu => {

                            var menuMatch = false;
                            var anyChecked = false;

                            // OR for menu
                            menu.Items.forEach(menuItem => {
                                if (menuItem.isChecked) {
                                    anyChecked = true;
                                    let field = item.Data[menu.FieldName];
                                    if ((Array.isArray(field) && field.includes(menuItem.FieldValue)) || (field === menuItem.FieldValue)) {
                                        menuMatch = true;
                                    }
                                }
                            });

                            if (anyChecked && !menuMatch) {
                                anyMenusFailed = true;
                            }
                        });

                        if (anyMenusFailed) {
                            item.isShown = false;
                        } else {
                            item.isShown = true;
                        }
                    }

                    this.Content.forEach(item => {

                        if (item.DisplayTile == "ChapteredContent") {
                            item.isShown = true;
                            //item.isShown = true;
                            item.ChapteredArticles.forEach(filterArticle);
                            item.visibleArticles = item.ChapteredArticles.filter(art => art.isShown).splice(0, 3);	// limit 3 max?

                            if (item.visibleArticles.length == 0) {
                                item.isShown = false;
                            }

                        } else if (typeof (item.Data) != "undefined") {
                            filterArticle(item);
                        }

                    });
                } else {
                    this.Content.forEach(item => {
                        item.isShown = true

                        if (item.DisplayTile == "ChapteredContent") {
                            item.visibleArticles = item.ChapteredArticles.map((x) => x).splice(0, 3);	// limit 3 max?

                            item.ChapteredArticles.forEach(chapteredItem => {
                                chapteredItem.isShown = true;

                            });
                        }
                    });
                }

                var shownContent = this.Content.filter(item => item.isShown);

                if (this.contentType == "teammember") {
                    // should already be sorted alphabetically
                    if (this.showAlphabetically) {
                        // don't sort by team
                        this.filteredContent = [{ TeamName: "", Team: shownContent }];
                    } else {

                        var teams = {};

                        // Collect team members by team(s)
                        shownContent.forEach((item) => {

                            item.Data.Team.forEach((teamName) => {
                                // If team doesn't exist in list, create
                                if (!Array.isArray(teams[teamName])) {
                                    teams[teamName] = [];
                                }

                                teams[teamName].push(item);
                            });
                        });

                        let results = [];

                        // Use the list of teams that we have in the menu specify the order of the teams

                        let teamList = this.Menus.find(element => element.FieldName == "Team").Items;

                        let anyTeamChecked = teamList.some(teamItem => teamItem.isChecked);

                        teamList.forEach((teamItem) => {
                            if (teams[teamItem.FieldValue] && (teamItem.isChecked || !anyTeamChecked)) {
                                results.push({ TeamName: teamItem.Label, Team: teams[teamItem.FieldValue] });
                            }
                        });

                        this.filteredContent = results;

                    }

                } else {
                    this.filteredContent = shownContent;
                }

                //console.log(this.$refs.menu);

                for (var r in this.$refs.menu.$refs) {
                    // console.log();
                    if (this.$refs.menu.$refs[r][0])
                        this.$refs.menu.$refs[r][0].close();

                    // console.log(this.$refs.menu.$refs[r]);
                }

                // vue hax - fixes issues with chaptered content not updating when filtering changes.
                this.forceRenderKey += 1;

                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs["tilegrid"]) {
                            ieGrid.doIEGrid(
                                this.$refs["tilegrid"].$el,
                                {
                                    numCols: 3,
                                    maxRows: 10,
                                    useGutters: true,
                                    gridRowTemplate: "260px 20px"
                                }
                            );
                        }
                    }, 250);
                });

            }
        }
    }
</script>

